const ORIGIN_APIROOT = '//pdvip.duba.net'

/** 前端域名 */
const FRONT_END_DOMAIN = 'pdfvip.ijinshan.com'

const WEB_VERSION = 1

/** sdk登录版本 */
const SDK_WEB_VERSION = 4

/** 微信AppID (PC) */
const WECHAT_LOGIN_APPID = 'wx5003cb8959975ce3'

/** 微信登录中转地址 */
const WECHAT_LOGIN_PROXY_URL = 'http://newvip.ijinshan.com/vip_login_proxy.html'

/** 微信登录配置 (PC) */
const WECHAT_LOGIN_CONF = {
  appid: WECHAT_LOGIN_APPID, // 您的微信appid
  responseType: 'code', // 返回类型，请填写code
  scope: 'snsapi_login', // 应用授权作用域，拥有多个作用域用逗号（,）分隔，网页应用目前仅填写snsapi_login即可
}

/** qq登录配置 */
const QQ_LOGIN_CONF = {
  client_id: '101554059', // 申请QQ登录成功后，分配给应用的appid。
  responseType: 'token', // 授权类型，此值固定为“token”
  scope: 'get_user_info', // scope=get_user_info,list_album,upload_pic,do_like 不传则默认请求对接口get_user_info进行授权。
}

export {
  ORIGIN_APIROOT,
  WEB_VERSION,
  SDK_WEB_VERSION,
  FRONT_END_DOMAIN,
  WECHAT_LOGIN_CONF,
  QQ_LOGIN_CONF,
  WECHAT_LOGIN_APPID,
  WECHAT_LOGIN_PROXY_URL
}
